module.exports = __webpack_public_path__ + "media/flags/kw-3d4d88cf.svg";